// extracted by mini-css-extract-plugin
export default {"brandPromo":"jF-z","carousel":"kF-z"};